let key = {};
let env = "production";
// export const API_URL = "https://backend-binflashloan.maticz.in";

// export const API_URL = "http://localhost:3001";
// export const API_URL = "https://sector8-backend.maticz.in/";//demo
// export const API_URL = "https://api.sector-8.ch";//live
// export const API_URL = "https://api.sector-8.ch";


// export const PORT = 2038;
// if (process.env.NODE_ENV === "production") {
if (env === "production") {
  console.log("Set Production Config");
  // const API_URL = "https://api.flashchainbot.com";
    // const API_URL = "https://digitalassests-backend.maticz.in/";
    const API_URL = "https://api.dadynamics.net";



  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: API_URL,
    FRONT_URL: "https://digiauser.dadynamics.net",
    ADMIN_URL: "https://control.dadynamics.net",
    getGeoInfo: "https://ipapi.co/json/",
    BACKEND_URL: 'https://api.dadynamics.net'
  };
} else if (env === "demo") {
  console.log("Set Demo Config");
  const API_URL = "https://digitalassests-backend.maticz.in/";

  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: API_URL,
    FRONT_URL: "https://digiasset-phase2.maticz.in/",
    ADMIN_URL: "https://digiasset-phase2-admin.maticz.in/",
    getGeoInfo: "https://ipapi.co/json/",
    BACKEND_URL: 'https://digitalassests-backend.maticz.in/'

  };
} else {
  console.log("Set Development Config");
  const API_URL = "http://localhost";
  key = {
    secretOrKey: "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
    CRYPTO_SECRET_KEY: "1234567812345678",
    Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
    API_URL: `${API_URL}:3001`,
    FRONT_URL: "http://localhost",
    ADMIN_URL: "http://localhost:3000/admin",
    getGeoInfo: "https://ipapi.co/json/",
    BACKEND_URL: 'http://localhost:3001'

  };
}

export default key;
